import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Event Date", value: "EVENT_DATETIME" },
  { label: "Creation Date", value: "CREATION_DATE" },
  { label: "Status", value: "STATUS" },
  { label: "Event Type", value: "EVENT_TYPE" },
  { label: "Booking Number", value: "BOOKING_NUMBER" },
] as const satisfies Array<{label: string, value: string}>;

export type PendingInventoryActivitySortByType = typeof sortByFields[number]['value'];

export interface PendingInventoryActivitySortParams extends SortParams {
  sortBy?: PendingInventoryActivitySortByType;
  sortDir?: SortDirType
}